import { makeReducer } from '../core/make-reducer';
import { makeActionCreators } from '../core/make-action-creators';
import * as API from '../core/api';

export const actions = {
  REQUEST: 'Dora/newsletters/REQUEST',
  RECEIVE: 'Dora/newsletters/SUCCESS',
  FAIL: 'Dora/newsletters/FAIL',
};

export default makeReducer({ actions });

const actionCreators = makeActionCreators({
  reducerName: 'newsletters',
  actions,
  requestDataCall: (store, params) => API.get(`newsletters`, params),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/newsletters/duck.js